import { ErrorWrapper } from './util'

import { OdooService } from './odoo.service'

const MODEL = 'l10n_latam.identification.type'
// const DOMAIN = { }
// const REQUIRED_FIELDS = ['id']
// const BASIC_FIELDS = ['display_name', 'parent_id', 'is_company']
const BASIC_FIELDS = []
const OPTS = { limit: 0 }

export class L10nLatamIdentificationTypeService extends OdooService {
  // eslint-disable-next-line no-useless-constructor
  constructor () {
    super()
  }

  static get entity () {
    return 'fields'
  }

  static async search (domain) {
    try {
      return await this.kwSearch(MODEL, domain, BASIC_FIELDS)
    } catch (error) {
      console.log(error)
    }
  }

  static async read (ids, fields = []) {
    try {
      return await this.kwRead(MODEL, ids, [...BASIC_FIELDS, ...fields])
    } catch (error) {
      console.log(error)
    }
  }

  static async list (domain) {
    try {
      return await this.kwSearchRead(MODEL, domain, BASIC_FIELDS, OPTS)
    } catch (error) {
      // console.log(error)
      throw new ErrorWrapper(error)
    }
  }

  static async create (data) {
    try {
      return await this.kwCreate(MODEL, data)
    } catch (error) {
      console.log(error)
      throw new ErrorWrapper(error)
    }
  }

  static async delete (id) {
    try {
      return await this.kwDelete(MODEL, id)
    } catch (error) {
      // console.log(error)
      throw new ErrorWrapper(error)
    }
  }

  static async update (id, data) {
    try {
      // console.log(data)
      return await this.kwUpdate(MODEL, id, data)
    } catch (error) {
      // console.log(error)
      throw new ErrorWrapper(error)
    }
  }
  
  static async execute (method, params) {
    try {
      console.log(method, params)
      return await this.kwExecute(MODEL, method, params)
    } catch (error) {
      console.log(error)
      throw new ErrorWrapper(error)
    }
  }
}
